import { AxiosError } from 'axios';
import { BugsnagOptions, log } from './bugsnag';

export const errorLogHandler = (
  error: string | Error | AxiosError | unknown,
  options: BugsnagOptions = {}
) => {
  if (typeof error === 'string') {
    error = new Error(error);
  }

  // TODO: Can add more here later....
  log(error, options);

  switch (options.severity) {
    case 'warning':
      console.warn(error);
      break;
    case 'info':
      console.info(error);
      break;
    default:
      console.error(error);
      break;
  }
};
